import { Data } from './types'

export const data: Data = [
  {
    id: 'EC8C9664F4CFB41C4B7ECD3B6C96E3A9',
    title: 'Not Started',
    label: 'hsl(345, 69%, 90%)',
    tasks: [
      {
        id: 'E368B9938746FA090D6AFD3628355133',
        heading: 'Untitled',
        content: 'Untitled',
        tags: [
          {
            id: 'D57AC45256849D9B13E2422D91580FB9',
            tag: '⌗ hash'
          }
        ]
      }
    ]
  },
  {
    id: '1D5BD3EB2CCA3D29F8C7D75FA097A1CC',
    title: 'In Progress',
    label: 'hsl(25, 80%, 77%)',
    tasks: []
  },
  {
    id: '78733D0DD44E9BBCA1D931C569676531',
    title: 'Done',
    label: 'hsl(345, 69%, 90%)',
    tasks: []
  }
]
